import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import { AddButton, UploadButton } from '@rd-web-markets/shared/dist/util/buttons';
const FinancialDetailButtons = _ref => {
  let {
    applicationSubmitted,
    handleCreateDetail,
    buttonStyle,
    setShowModal,
    contractor,
    loading
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, contractor.contractor_type === 'bfsz' && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(AddButton, {
    disabled: applicationSubmitted,
    onClick: () => handleCreateDetail('estimate'),
    loading: loading,
    icon: "add",
    text: t('add_estimate'),
    variant: 'primary',
    className: 'mt-2',
    style: buttonStyle
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(AddButton, {
    disabled: applicationSubmitted,
    onClick: () => handleCreateDetail('offer'),
    loading: loading,
    icon: "add",
    text: t('add_offer'),
    variant: 'primary',
    className: 'mt-2',
    style: buttonStyle
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(UploadButton, {
    onClick: () => setShowModal(true),
    disabled: applicationSubmitted,
    loading: loading,
    text: t('upload_file'),
    variant: 'primary',
    className: 'mt-2',
    style: buttonStyle
  }))));
};
export default FinancialDetailButtons;